export default __webpack_public_path__ + "static/media/Home Textiles.27888e3d.png";